export class BaseDbClass {
    id?: string;
    createdById: string;
    createdBy: string;
    createdDate: Date | string;
    updatedById?: string;
    updatedBy?: string;
    updatedAt?: Date;
}